module.exports = __webpack_public_path__ + "img/pr-5.e5523be6.png";